var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 17.0625C4.5525 17.0625 0.9375 13.4475 0.9375 9C0.9375 4.5525 4.5525 0.9375 9 0.9375C13.4475 0.9375 17.0625 4.5525 17.0625 9C17.0625 13.4475 13.4475 17.0625 9 17.0625ZM9 2.0625C5.175 2.0625 2.0625 5.175 2.0625 9C2.0625 12.825 5.175 15.9375 9 15.9375C12.825 15.9375 15.9375 12.825 15.9375 9C15.9375 5.175 12.825 2.0625 9 2.0625Z",
    fill: "#E60A2B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.783 11.9476C11.6855 11.9476 11.588 11.9251 11.498 11.8651L9.17297 10.4776C8.59547 10.1326 8.16797 9.37507 8.16797 8.70757V5.63257C8.16797 5.32507 8.42297 5.07007 8.73047 5.07007C9.03797 5.07007 9.29297 5.32507 9.29297 5.63257V8.70757C9.29297 8.97757 9.51797 9.37507 9.75047 9.51007L12.0755 10.8976C12.3455 11.0551 12.428 11.4001 12.2705 11.6701C12.158 11.8501 11.9705 11.9476 11.783 11.9476Z",
    fill: "#E60A2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockRed);
export default __webpack_public_path__ + "static/media/clock-red.c4df2d1c631155b3b7e26ff712fd6476.svg";
export { ForwardRef as ReactComponent };